import {createContext, useContext, useState} from 'react';

const DateContext = createContext();

const SESSION_DATE_KEY = 'druidvision_selected_date';
const SESSION_POLLING_KEY = 'druidvision_polling_state';
const SESSION_STRATEGY_KEY = 'druidvision_selected_strategy';

export const DateProvider = ({children}) => {
    // Inizializza la data da sessionStorage (se esiste)
    const [selectedDate, setSelectedDateState] = useState(() => {
        const savedDate = sessionStorage.getItem(SESSION_DATE_KEY);
        return savedDate || "";
    });

    // Inizializza il polling da sessionStorage (default: true)
    const [isPolling, setIsPollingState] = useState(() => {
        const saved = sessionStorage.getItem(SESSION_POLLING_KEY);
        return saved === null ? true : saved === 'true';
    });

    // Inizializza la strategia da sessionStorage (se esiste)
    const [selectedStrategy, setSelectedStrategyState] = useState(() => {
        const savedStrategy = sessionStorage.getItem(SESSION_STRATEGY_KEY);
        return savedStrategy || null;
    });

    // Contatore errori consecutivi e flag connessione riuscita (non persistiti)
    const [consecutiveErrors, setConsecutiveErrors] = useState(0);
    const [hasConnectedOnce, setHasConnectedOnce] = useState(false);

    // Wrapper per setSelectedDate che salva anche in sessionStorage
    const setSelectedDate = (date) => {
        setSelectedDateState(date);
        if (date) {
            sessionStorage.setItem(SESSION_DATE_KEY, date);
        } else {
            sessionStorage.removeItem(SESSION_DATE_KEY);
        }
    };

    // Wrapper per setIsPolling che salva anche in sessionStorage
    const setIsPolling = (polling) => {
        setIsPollingState(polling);
        sessionStorage.setItem(SESSION_POLLING_KEY, polling.toString());
    };

    // Wrapper per setSelectedStrategy che salva anche in sessionStorage
    const setSelectedStrategy = (strategy) => {
        setSelectedStrategyState(strategy);
        if (strategy !== null) {
            sessionStorage.setItem(SESSION_STRATEGY_KEY, strategy);
        } else {
            sessionStorage.removeItem(SESSION_STRATEGY_KEY);
        }
    };

    return (
        <DateContext.Provider value={{
            selectedDate,
            setSelectedDate,
            isPolling,
            setIsPolling,
            selectedStrategy,
            setSelectedStrategy,
            consecutiveErrors,
            setConsecutiveErrors,
            hasConnectedOnce,
            setHasConnectedOnce
        }}>
            {children}
        </DateContext.Provider>
    );
};

export const useDate = () => {
    const context = useContext(DateContext);
    if (context === undefined) {
        throw new Error('useDate deve essere usato all\'interno di un DateProvider');
    }
    return context;
};
